module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic.090d2836.ttf";